// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0e767e84","453":"2a404cc4","455":"e8ba5d43"}[chunkId] + ".chunk.js";
};